import { container } from "tsyringe";
import { HangingApiRepository } from "../../repositories/api/HangingApiRepository";
import ApiService from "../../services/ApiService";
import { HangingIncomingMapper } from "@/data/persistences/mappers/HangingIncomingMapper";
import { HangingLastMileMapper } from "@/data/persistences/mappers/HangingLastMileMapper";
import { HangingEndpoint } from "../../endpoints/HangingEndpoint";
import { SttHangingPresenter } from "@/app/ui/presenters/SttHangingPresenter";
import { HangingMapper } from "@/data/persistences/mappers/HangingMapper";

export class HangingComponent {
  public static init() {
    container.register<HangingApiRepository>(HangingApiRepository, {
      useFactory: (d) => {
        return new HangingApiRepository(
          d.resolve(ApiService),
          d.resolve(HangingIncomingMapper),
          d.resolve(HangingLastMileMapper),
          d.resolve(HangingMapper),
          d.resolve(HangingEndpoint)
        );
      }
    });
    container.register<HangingIncomingMapper>(HangingIncomingMapper, {
      useClass: HangingIncomingMapper
    });
    container.register<HangingLastMileMapper>(HangingLastMileMapper, {
      useClass: HangingLastMileMapper
    });
    container.register<SttHangingPresenter>(SttHangingPresenter, {
      useFactory: (d) => {
        return new SttHangingPresenter(d.resolve(HangingApiRepository));
      }
    });
  }
}
